<template>
  <div>
    <van-nav-bar title="会员中心" class="">
      <template #left>
        <!-- <span
          v-if="!$store.state.loginType"
          @click="$router.push('/login')"
          class="navTextDesign"
          >签到</span
        >
        <span
          v-if="$store.state.loginType"
          @click="signIn"
          class="navTextDesign"
          >签到</span
        > -->
        <div id="lineUrlDropMenu">
          <van-dropdown-menu id="lineUrlDropdown">
            <van-dropdown-item v-model="activeLineUrl" :options="lineArray" @change="changeTab" />
          </van-dropdown-menu>
        </div>
      </template>
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span
          @click="openQchat()"
          class="navTextDesign"
          >在线客服</span
        >
      </template>
    </van-nav-bar>

    <!-- <van-nav-bar v-if="!$store.state.loginType" title="会员中心" class="">
      <template #right>
        <span @click="$router.push('/login')" class="navTextDesign">签到</span>
        <van-icon name="chat-o" size="25" @click="openQchat()" />
      </template>
    </van-nav-bar> -->
    <van-pull-refresh v-model="isLoading" @refresh="getUser" style="overflow: visible !important;">
      <div class="outside-container">
      <div class="members common-bg1">
        <van-row style="text-align: right; padding: 20px 10px 0;">

            <van-button
              round
              plain
              v-if="!$store.state.loginType"
              type="danger"
              size="small"
              class="members-button"
              style="
                min-height: auto;
                border-radius: 6px;
                margin-top: -10px;
                border: 1px solid #D02E27;
                color: #D02E27;
                font-size: 14px;
                text-align: center;
              "
              @click="$router.push('/login')"
              >签到</van-button
            >
            <van-button
              round
              plain
              v-if="$store.state.loginType"
              type="danger"
              size="small"
              class="members-button signIn"
              style="
                min-height: auto;
                border-radius: 6px;
                margin-top: -10px;
                border: 1px solid #D02E27;
                color: #D02E27;
                font-size: 14px;
                text-align: center;
              "
              @click="signIn"
              >签到送现金</van-button
            >

            <van-popover
              v-model:show="showTooltip"
              placement="bottom"
              theme="dark"
              trigger="click"
            >
              <template #reference>
                <van-button
                  round
                  plain
                  type="default"
                  size="small"
                  class="help-button"
                >
                ?
                </van-button>
              </template>
          <div class="tooltip-content">{{ tooltipText }}</div>
        </van-popover>
            
        </van-row>
        <div class="members-img">
          <!-- <img
            :src="$store.state.login_logo_url"
            style="width: 100%"
            v-if="$store.state.login_logo_url"
          /> -->
          <img
            :src="require('../assets/images/login_logo.png')"
            style="width: 100%"
          />
        </div>

        <van-row
          v-if="$store.state.loginType"
          style="padding-top: 10px;margin-top:-15px; text-align: center;"
        >
          <van-col span="8">
            <!-- <router-link to="recharge"> -->
            <van-button
              round
              type="danger"
              size="normal"
              class="members-button"
              style="height: 26px; background-color: #D02E27; border:1px solid #D02E27"
              @click="goToRechargePage()"
              >充值</van-button
            >
            <!-- </router-link> -->
          </van-col>
          <van-col span="8"
            ><p class="members-user">{{ phone }}</p></van-col
          >
          <van-col span="8">
            <!-- <router-link to="withdrawal"> -->
            <van-button
              round
              type="info"
              size="normal"
              class="members-button"
              style="height: 26px; background-color: #0D268D;border: #0D268D;"
              @click="goToWithdrawPage()"
              >提现</van-button
            >
            <!-- </router-link> -->
          </van-col>
        </van-row>
        <div v-if="!$store.state.loginType">
          <van-row style="padding-top: 10px; text-align: center;margin-top:-15px;">
            <van-col span="11" style="text-align: right">
              <router-link to="/login">
                <van-button
                  round
                  plain
                  type="danger"
                  size="normal"
                  class="members-button"
                  style="height: 26px; width: 65px; border-radius: 8px"
                  >登录</van-button
                >
              </router-link>
            </van-col>
            <van-col span="2"></van-col>
            <van-col span="11" style="text-align: left">
              <router-link to="/zhuce9999">
                <van-button
                  round
                  plain
                  type="danger"
                  size="normal"
                  class="members-button"
                  style="height: 26px; width: 65px; border-radius: 8px"
                  >注册
                </van-button>
              </router-link>
            </van-col>
          </van-row>
        </div>
      </div>
      </div>
      <!-- <van-row v-if="$store.state.loginType" style="padding: 10px 10px 5px">
        <van-col span="12">
          <p class="members-money">余额: {{ cash }}元</p>
        </van-col>
        <van-col span="12" style="text-align: right"
          ><p class="members-money" style="padding-right: 6px">
            代金券: {{ voucherAmount }}元
          </p></van-col
        >
      </van-row>
      <van-row v-if="$store.state.loginType" style="padding: 0px 10px 5px">
        <van-col span="12">
          <p class="members-money">时时宝: {{ timebaoAccount }}元</p>
        </van-col>
        <van-col v-if="vipRewardTradeStatus==1" span="12" style="text-align: right"
          ><p class="members-money" style="padding-right: 6px">
            VIP奖励余额: {{ user_vip_reward_balance }}元
          </p></van-col
        >
      </van-row> -->
        <!-- ============================= 1 ======================================== -->
       
  <div class="common-bg">
    <van-cell
          is-link @click="gotoLink('/member/detailed_log')"
        >
          <template #title>
            <span class="custom-title"><van-icon name="column" style="margin-right: 9px;" />总资产</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ total.toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        <van-cell
          is-link @click="gotoLink('account')"
        >
          <template #title>
            <span class="custom-title"><van-icon name="column" style="margin-right: 9px;" />证券主账户</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ cash }}元</span
            >
          </template>
        </van-cell>
        <van-cell
          is-link
          @click="gotoLink('lifetime_reward')"
          v-if="lifetimeRewardStatus==1"
        > 
        <template #title>
            <span class="custom-title"><van-icon name="medal" style="margin-right: 9px;" />终生奖励</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              > {{ user_lifetime_reward_balance }}元</span
            >
          </template>
        </van-cell>


        <!--stable coin bao-->
           <van-cell
          is-link
          class="flexible-height"
          @click="gotoLink('stable_coinbao')"
         v-if="stablebao_status == 1"
        >
        <template #title>
          <div style="display: flex; flex-direction: column;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span class="custom-title" style="margin-top: 0px !important;"> 
                <van-icon name="bag" style="margin-right: 9px;" />稳定币基金
              </span>
              <span
                v-if="$store.state.loginType"
                style="color: #D02E27; font-size: 14px; margin-top: -2px;"
              >
                {{ stable_coinbao_account }}元
              </span>
            </div>

          </div>
        </template>

        </van-cell>

  <van-cell
         
          class="flexible-height"
         v-if="stablebao_status == 1"
        >
        <template #title>
          <div style="display: flex; flex-direction: column;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span class="custom-title" style="margin-top: 0px !important;"> 
                <van-icon name="bag" style="margin-right: 9px;" />稳定币持仓
              </span>
              <span
                v-if="$store.state.loginType"
                style="color: #D02E27; font-size: 14px; margin-top: -2px;margin-right:20px;"
              >
                {{ stable_coinbao_product_pending_amount }}元
              </span>
            </div>

          </div>
        </template>

        </van-cell>



        <van-cell
          is-link
          @click="gotoLink('vip_reward')"
          v-if="vipRewardTradeStatus==1"
        > 
        <template #title>
            <span class="custom-title"><van-icon name="vip-card" style="margin-right: 9px;" />VIP奖励</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              > {{ user_vip_reward_balance }}元</span
            >
          </template>
        </van-cell>
        <van-cell
          is-link
          class="flexible-height"
          @click="gotoLink('time_bao')"
          v-if="timebao_status == 1"
        >
        <template #title>
          <div style="display: flex; flex-direction: column;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span class="custom-title" style="margin-top: -5px !important;"> 
                <van-icon name="bag" style="margin-right: 9px;" />时时宝
              </span>
              <span
                v-if="$store.state.loginType"
                style="color: #D02E27; font-size: 14px; margin-top: -2px;"
              >
                {{ timebaoAccount }}元
              </span>
            </div>
            <span style="font-size: 10px; margin-left: 20px;color:#D02E27">
              (炒股理财时时赚钱 年化收益 {{ timebao_annualized_rate }}%)
            </span>
          </div>
        </template>

        </van-cell>






        <van-cell
          is-link
          class="flexible-height"
          @click="gotoLink('gxpay')"
           v-if="gxpayStatus==1"
        >
          <template #title>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span class="custom-title" style="margin-top: -5px !important;"> 
                  <van-icon name="gift-card" style="margin-right: 9px;" />GXPAY <span style="color:#D02E27">数字货币交易</span>
                </span>   
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell
          is-link
          @click="gotoLink('voucher')"
         
        >
          <template #title>
            <span class="custom-title"><van-icon name="balance-pay" style="margin-right: 9px;" />代金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ voucherAmount }}元</span
            >
          </template>
        </van-cell>
      </div>

      
        <!-- ============================= 2 ======================================== -->
        <div class="common-bg">
        <van-cell is-link @click="gotoLink('agency')">
          <template #title>
            <span class="custom-title"><van-icon name="good-job" style="margin-right: 9px;" />推广账户</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ parseFloat(agent_account).toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('friend_coupon')">
          <template #title>
            <span class="custom-title"><van-icon name="coupon" style="margin-right: 9px;" />可送好友现金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ parseFloat(friend_cash_coupon).toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('user_coupon')">
          <template #title>
            <span class="custom-title"><van-icon name="other-pay" style="margin-right: 9px;" />我的好友现金券</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >{{ parseFloat(my_cash_voucher).toFixed(2) }}元</span
            >
          </template>
        </van-cell>
        </div>
      
        <!-- ============================= 3 ======================================== -->
        <div class="common-bg">
        <van-cell is-link @click="gotoLink('risk_control')">
          <template #title>
            <span class="custom-title">
              <van-badge v-if="unread_risk_count > 0" dot color="#D02E27">
                <van-icon name="warning" style="margin-right: 9px;" />
              </van-badge>

              <van-icon
                v-else
                name="warning"
                style="margin-right: 9px;"
              />

              风控通知
              <span v-if="unread_risk_count > 0" style="color:#D02E27">
                （{{ unread_risk_count }}条通知）
              </span>
            </span>
          </template>
        </van-cell>

        <van-cell is-link @click="gotoLink('announcement')" >
          <template #title>
            <span class="custom-title"><van-icon name="notes-o" style="margin-right: 9px;" />平台公告</span>           
          </template>
        </van-cell>

        <van-cell
          is-link
          @click="gotoLink('information')"
        ><template #title>
            <span class="custom-title"><van-icon name="setting" style="margin-right: 9px;" />完善个人资料</span>
          </template>
        </van-cell>
        </div>
        
        <!-- ============================= 4 ======================================== -->
        <div class="common-bg">
        <van-cell is-link @click="gotoLink('/create_capital_accounts')">
          <template #title>
            <span class="custom-title"><van-icon name="balance-o" style="margin-right: 9px;" />申请配资</span>
          </template>
        </van-cell>
        <van-cell is-link @click="gotoLink('/capital_account?activeTab=2')">
          <template #title>
            <span class="custom-title"><van-icon name="bar-chart-o" style="margin-right: 9px;" />配资账户</span>
            <span
              v-if="$store.state.loginType"
              style="float: right; color: #D02E27;font-size: 14px;"
              >保证金{{ bond }}元</span
            >
          </template>
        </van-cell>

        <van-cell is-link @click="gotoLink('/trading')" >
          <template #title>
            <span class="custom-title"><van-icon name="chart-trending-o" style="margin-right: 9px;" />实盘交易</span>
          </template>
        </van-cell>

        <van-cell is-link @click="gotoLink('/quotes')">
          <template #title>
            <span class="custom-title"><van-icon name="gem" style="margin-right: 9px;" />自选股票</span>
          </template>
        </van-cell>

        <van-cell
          is-link
          @click="gotoLink('entrust_inquiry')"
        ><template #title>
            <span class="custom-title"><van-icon name="cash-back-record" style="margin-right: 9px;" />委托查询</span>
          </template>
        </van-cell>

        <van-cell
          is-link
          @click="gotoLink('withdrawal_inquiry')"
        ><template #title>
            <span class="custom-title"><van-icon name="refund-o" style="margin-right: 9px;" />撤单查询</span>
          </template>
        </van-cell>

        <van-cell is-link @click="gotoLink('deal_inquiry')" >
          <template #title>
            <span class="custom-title"><van-icon name="completed" style="margin-right: 9px;" />成交查询</span>
          </template>
        </van-cell>

        <van-cell
          is-link
          @click="gotoLink('position_inquiry')"
        > <template #title>
            <span class="custom-title"><van-icon name="peer-pay" style="margin-right: 9px;" />持仓查询</span>
          </template>
        </van-cell>
        </div>
    
        
        <!-- ============================= 5 ======================================== -->
        <!-- <van-cell
          title="线路切换"
          is-link
          to=""
          @click="lineSwitching = true"
        /> -->
        <!-- <van-row style="padding: 10px 10px 0px;">
          <van-col span="12">
            <p class="version">当前线路</p> 
          </van-col>
          <van-col span="12" style="text-align: right; font-size: small; color: #727573" >
            {{ this.lineArray[this.activeLineUrl].text }}
          </van-col>
        </van-row> -->
        <div class="common-bg">
        <van-cell is-link @click="$router.push('/api_line_selector')">
          <template #title>
            <span class="custom-title"><van-icon name="guide-o" style="margin-right: 9px;" />当前线路</span>
            <span style="float: right;font-size: 13px;"
              >{{ lineArray[activeLineUrl].text }}</span
            >
          </template>
        </van-cell>

        <!-- <van-cell title="联系客服" is-link to="/service" /> -->
        <van-cell is-link @click="openQchat()">
          <template #title>
            <span class="custom-title"><van-icon name="phone" style="margin-right: 9px;" />联系客服</span>
          </template>
        </van-cell>
        <!-- ============================= 6 ======================================== -->
        <van-row v-if="finance_status == 1 || holiday_status === 1">
        </van-row>
        <div>
          <van-cell
            is-link
            @click="gotoLink('finance_fund')"
            v-if="finance_status == 1"
          ><template #title>
            <span class="custom-title"><van-icon name="paid" style="margin-right: 9px;" />定期宝</span>
          </template>
        </van-cell>
        </div>
        <div>
          <van-cell
            is-link
            @click="gotoLink('holiday_fund')"
            v-if="holiday_status == 1"
          ><template #title>
            <span class="custom-title"><van-icon name="pending-payment" style="margin-right: 9px;" />节日宝</span>
          </template>
        </van-cell>
        </div>
        <van-cell>
          <template #title>
            <span class="custom-title"><van-icon name="idcard" style="margin-right: 9px;" />版本号 / 包号</span>
            <span style="float: right;font-size: 14px;"
              >{{ version }} / {{ description }}</span
            >
          </template>
        </van-cell>
      </div>

      <!-- <van-row style="padding: 0px 10px 10px">
          <van-col span="12">
            <p class="version">版本号</p> 
          </van-col>
          <van-col span="12" style="text-align: right; color: #727573" >
            {{ version }}
          </van-col>
        </van-row> -->

      <div style="margin: 25px 14px 0px">
        <van-button
          v-if="$store.state.loginType"
          round
          type="danger"
          color="#D02E27" 
          block
          @click="exitLogin"
          >退出登录</van-button
        >
      </div>
    </van-pull-refresh>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->

    <van-popup v-model="isRealNameVerified" style="width: 70%; height: 158px">
      <div>
        <h5 style="padding-top: 1px; text-align: center">您还没有实名</h5>
        <h5 style="padding-top: 1px; text-align: center">
          请实名激活<span>&nbsp;{{ sys_give_voucher_amount }}&nbsp;</span>元礼金
        </h5>
        <span
          ><van-button
            type="danger"
            size="large"
            @click="cancel"
            style="
              width: 40%;
              margin-left: 7%;
              height: 30%;
              padding: 3px;
              margin-top: 10px;
              border-radius: 6px;
            "
            >取消
          </van-button>
          <van-button
            type="danger"
            size="large"
            @click="goToRealName"
            style="
              width: 40%;
              margin-left: 5%;
              height: 30%;
              padding: 3px;
              margin-top: 10px;
              border-radius: 6px;
            "
            >立即实名
          </van-button>
        </span>
      </div>
    </van-popup>
    <van-popup v-model="isFirstTimeRecharge" closeable class="first-time-recharge-popup" style="width: 90%; height: 28%; padding: 10px;" @opened="popupButton">
      <div class="popupContent">
        <p style="text-align: center; font-size: 17px; display: none">首充礼品清单</p>
        <div v-html="before_recharge" ref="rechargeContent"></div>
      </div>
    </van-popup>
    <van-popup v-model="isFirstTimeTrading" style="width: 90%; height: auto">
      <div class="popupContent">
        <p style="text-align: center; font-size: 17px">首充礼品清单</p>
        <div v-html="before_recharge"></div>
        <van-button
          type="danger"
          size="large"
          @click="cancelTrade"
          style="width: 40%; margin-left: 7%; height: 30%"
          >取消
        </van-button>
        <van-button
          type="danger"
          size="large"
          @click="goToTrade"
          style="width: 40%; margin-left: 5%; height: 30%"
          >立即配资交易
        </van-button>
      </div>
    </van-popup>

    <van-popup v-model="lineSwitching" round :style="{ width: '70%' }">
      <!-- <div class="download">
        <h4 class="downloadTitle">Line Switching</h4>
        <van-divider />
        <van-radio-group>
          <van-cell-group>
            <van-cell title="Line 1" clickable @click="radio = '1'">
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
            <van-cell title="Line 2" clickable @click="radio = '2'">
              <template #right-icon>
                <van-radio name="2" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-divider />
        <van-button
          type="danger"
          size="large"
          @click="download"
          style="width: 50%; margin-left: 5%"
          >a
        </van-button>
        <van-divider />
        <van-button
          type="danger"
          size="large"
          @click="download"
          style="width: 50%; margin-left: 5%"
          >a
        </van-button>
      </div> -->
      <h5 style="padding-top: 1px; text-align: center">线路切换</h5>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in lineTypes"
            :key="index"
            :title="item.name"
            clickable
            @click="radioName = item.url"
          >
            <template #right-icon>
              <input
                type="radio"
                :value="item.url"
                :checked="item.url == urlBase"
                name="switch_change"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div style="padding-top: 12px">
        <van-button
          type="info"
          size="small"
          plain
          @click="cancelLines"
          style="
            width: 26%;
            margin-left: 17%;
            margin-bottom: 5%;
            border-radius: 5px;
          "
          >取消
        </van-button>

        <van-button
          type="info"
          size="small"
          plain
          @click="ChangeLine"
          style="
            width: 26%;
            margin-left: 13%;
            margin-bottom: 5%;
            border-radius: 5px;
          "
          >确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { version, description } from './../../package.json'
import { ref } from "vue";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

export default {
  name: "Members",
 
  data() {
    return {
      version: version,
      description: description,
      isLoading: false,
      phone: "",
      cash: 0.0,
      bond: 0.0,
      timebao_annualized_rate: 0.0,
      timebao_interest_amount:0.0,
      timebaoAccount: 0.0,
      user_vip_reward_balance: 0.0,
      user_lifetime_reward_balance : 0.0,
      vipRewardTradeStatus: 0,
      lifetimeRewardStatus : 0,
      gxpayStatus: 0,
      voucherAmount: 0.0,
      agent_account: 0.0,
      my_cash_voucher: 0.0,
      friend_cash_coupon: 0.0,
      isRealNameVerified: false,
      isFirstTimeRecharge: false,
      isFirstTimeTrading: false,
      lineSwitching: false,
      sys_give_voucher_amount: "",
      hk_official:"",
      before_recharge: "",
      before_trading: "",
      isRealNamePopShow: false,
      isRechargePopShow: false,
      radio: 1,
      radioName: "",
      lineTypes: JSON.parse(localStorage.getItem("api_lines") || "[]"),
      //lineTypes: [],
      domainList: JSON.parse(localStorage.getItem("api_lines") || "[]"),
      urlBase: localStorage.getItem("lineUrl"),
      finance_status: "",
      holiday_status: "",
      timebao_status: "",
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      qserver_url: "",
      lineArray: [{
        text: `线路`,
        value: 0,
      }],
      activeLineUrl: ref(0),
      selectedLine: '',
      showTooltip: false,
      tooltipText: "登录可读!",
      checkingDays: '',
      checkingCashAmount: '',
      checkingVoucherAmount: '',
      checkingrechargeAmount: '',
      clientIp: '',
      clientIpFetchUrl:'',
      stable_coinbao_annualized_interest_rate:0,
      stable_coinbao_account:0,
      stablebao_status: 0,
      unread_risk_count:0,
      stable_coinbao_product_pending_amount:0,
      total: 0,
    };
  },
  methods: {
      getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebao_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
     //get cleint ip url frm config
     getClientIpConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "sysconfig",
            name: "client_ip_get_gateway",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.clientIpFetchUrl = resData.data;
          }
        });
    },
    //New UI change in recharge PopUP
    popupButton() {
      this.$nextTick(() => {
        const rechargeContent = this.$refs.rechargeContent;
        if (!rechargeContent) return;

        // Get all child nodes (including <p>, <div>, images)
        const originalContent = Array.from(rechargeContent.childNodes);

        // Find only the <p> elements for button positioning
        const elements = rechargeContent.querySelectorAll("p");
        if (elements.length < 2) return;

        const targetElement1 = elements[1]; 
        const targetElement2 = elements[2]; 

        rechargeContent.querySelectorAll("img").forEach((img) => {
          img.style.width = "20px";
          img.style.height = "20px";
          img.style.borderRadius = "50%";
          img.style.objectFit = "cover";
        });

        // Function to create a row where <p> and button stay in the same line
        const createRowContainer = (textElement, buttonElement) => {
          const row = document.createElement("div");
          row.style.display = "flex";
          row.style.justifyContent = "space-between";
          row.style.alignItems = "center";
          row.style.width = "100%";
          row.style.marginBottom = "5px";

          const textWrapper = document.createElement("div");
          textWrapper.style.flex = "1";
          textWrapper.style.textAlign = "left";
          textWrapper.appendChild(textElement);

          const buttonWrapper = document.createElement("div");
          buttonWrapper.style.flex = "0";
          buttonWrapper.style.marginLeft = "auto"; 
          buttonWrapper.appendChild(buttonElement);

          row.appendChild(textWrapper);
          row.appendChild(buttonWrapper);
          return row;
        };

        // Create "SignIN" button
        const signInButton = document.createElement("button");
        signInButton.textContent = "签到送现金";
        signInButton.className = "van-button van-button--danger van-button--mini";
        signInButton.style.height = "30px";
        signInButton.style.width = "80px";
        signInButton.style.fontSize = "12px";

        signInButton.addEventListener("click", (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.signIn();
        });

        // Create "Recharge" button
        const rechargeButton = document.createElement("button");
        rechargeButton.textContent = "立即充值";
        rechargeButton.className = "van-button van-button--danger van-button--mini";
        rechargeButton.style.height = "30px";
        rechargeButton.style.width = "80px";
        rechargeButton.style.fontSize = "12px";

        rechargeButton.addEventListener("click", (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.goToRecharge();
        });

        // Preserve all existing content (including non-<p> elements)
        rechargeContent.innerHTML = ""; 

        // Re-add all original content while modifying only <p> elements
        originalContent.forEach((element) => {
          if (element === targetElement1) {
            rechargeContent.appendChild(createRowContainer(targetElement1, signInButton));
          } else if (element === targetElement2) {
            rechargeContent.appendChild(createRowContainer(targetElement2, rechargeButton));
          } else {
            rechargeContent.appendChild(element); // Preserve all other content
          }
        });
      });
    },
    openQchat() {
      // if (Capacitor.getPlatform() === "android") {
      //   //check if android app, if android app use native plugin to open popup
      //   Browser.open({ url: this.qserver_url });
      // } else {
      //   window.open(this.qserver_url);
      // }
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    gotoLink(link) {
      if (sessionStorage.getItem("token")) {
      if(link == "gxpay"){
        let that = this;
       that
         .$http({
           url: "/",
           method: "POST",
           data: {
             nozzle: "gxpay_thirdparty_digital_currency",
             token: sessionStorage.getItem("token"),
           },
         })
         .then((ret) => {
           let resData = ret.data;
           if (resData.code == 1) {
            if(resData.data.user == true){
              this.$router.push(link); 
            }
           else{
           window.open(resData.data.homeUrl,'_blank');
           }

           }
         });
      }
      else{
        this.$router.push(link);

      }
      } else {
        this.$router.push("/login");
      }
    },

    // goToRechargePopContent() {
    //   this.$router.push({
    //     path: "/activity/popup_content?activityid=recharge_popup_image_mob",
    //   });
    // },
    signIn() {
      let that = this;
      $('.signIn').prop('disabled',true);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "checkin",
            token: sessionStorage.getItem("token"),
            ip : that.clientIp,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.$toast.success(resData.msg);
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    //Fetch user IP
    getClientIP() {
    let that = this;
    $.ajax({
       url: "https://ifconfig.me/all.json",
       type: "GET",
      success: function (response) {
        console.log("IP:", response.ip_addr);
          that.clientIp = response.ip_addr;       
      },
      error: function (xhr, status, error) {
        var clientIpUrl=that.clientIpFetchUrl.split(',');
          var url=clientIpUrl[0];
          $.ajax({
          url: url, 
          type: "GET",
          success: function (response) {
            var a=that.clientIpFetchUrl.split(',')[1].trim();
              that.clientIp = response[a]; 
              console.log("client ip",that.clientIp);
          },
          error: function (xhr, status, error) {
            console.error("Error fetching IP:", error);
          }
        });
      }
    });
    },

    // ==================== Check trade channel before go to recharge and withdraw  page =============
    goToRechargePage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/recharge");
      }
    },

    goToWithdrawPage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/withdrawal");
      }
    },

    // ============= get the content of trade channel popup agreement ===========

    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // that.$toast.fail(res.data.msg);
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },

    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "sys_give_voucher_amount",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.sys_give_voucher_amount = res.data.data;
          } else {
          }
        });
    },
    hkWebConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            name: "hk_official_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.hk_official = res.data.data;
            
            if (Capacitor.getPlatform() === "android") {
              Browser.open({ url: that.hk_official });
            } else {
              window.open(that.hk_official, "_blank");
            }


          } else {
          }
        });
    },
    rechargeConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "before_recharge",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.before_recharge = res.data.data;
          } else {
          }
        });
    },
    getUser() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            let resData = res.data;
            that.isLoading = false;
            if (res.data.code === 1) {
              that.cash = resData.data.cash;
              that.timebao_annualized_rate =
                resData.data.timebao_annualized_rate;
              that.timebao_interest_amount = resData.data.timebao_interest_amount;
              that.timebaoAccount = resData.data.timebao_accout;
              that.vipRewardTradeStatus = resData.data.vipRewardTradeStatus;
              that.lifetimeRewardStatus = resData.data.lifetime_reward;
              that.user_vip_reward_balance = resData.data.vipRewardTradeStatus==1?Number(resData.data.user_vip_reward_balance):0;
              that.user_lifetime_reward_balance = resData.data.lifetime_reward==1?Number(resData.data.lifetime_reward_balance):0;
              that.bond = resData.data.bond;
              that.agent_account = resData.data.agent_account;
              that.friend_cash_coupon = resData.data.friend_cash_coupon;
              that.my_cash_voucher = resData.data.my_cash_voucher;
              that.voucherAmount = resData.data.voucher_management;
              that.phone = resData.data.phone;
              that.finance_status = resData.data.finance_status;
              that.holiday_status = resData.data.holiday_status;
              that.timebao_status = resData.data.timebao_status;
              console.log('t',that.timebao_status)
              that.trade_channel_status = resData.data.trade_channel_status;
              that.tooltipText = resData.data.check_in_remainder;
              that.gxpayStatus = resData.data.gxpaymenu_status;
              that.stable_coinbao_annualized_interest_rate=resData.data.stable_coinbao_annualized_interest_rate;
              that.stable_coinbao_account=resData.data.stable_coinbao_account;
              that.unread_risk_count=resData.data.unreadRiskCount;
              that.stable_coinbao_product_pending_amount=resData.data.stable_coinbao_product_pending_amount;
              that.total = Number(resData.data.cash) + Number(resData.data.bond) + Number(resData.data.voucher_management) + Number(resData.data.agent_account)+ Number(that.user_vip_reward_balance)+ Number(that.user_lifetime_reward_balance)+ Number(resData.data.timebao_accout)+Number(resData.data.stable_coinbao_account)+Number(resData.data.stable_coinbao_product_pending_amount);
              console.log("total",that.total);
              that.$store.commit("setRiskUnreadCount", that.unread_risk_count || 0);
              // that.checkingCashAmount = resData.data.sys_checkin_cash_amount;
              // that.checkingDays = resData.data.sys_checkin_days;
              // that.checkingVoucherAmount = resData.data.sys_checkinamount;
              // that.checkingrechargeAmount = resData.data.sys_checkin_recharge_amount;

              // that.tooltipText = "充值 < " + that.checkingrechargeAmount + "，签到每日送 " + that.checkingVoucherAmount + "元代金券。"
              //                   + "充值 >= " + that.checkingrechargeAmount + ",签到每日送 " + that.checkingCashAmount + "元现金 [和"+ that.checkingVoucherAmount +"元代金券]，可签到"
              //                   + that.checkingDays + "次，即得" + parseInt(that.checkingCashAmount * that.checkingDays) + "元。"
              //                   + "已经签到" + that.checkingDays + "次，再次充值" + that.checkingrechargeAmount + "后可再次签到" + that.checkingDays + "次";

              that.$store.commit("changeUser", resData.data);
              if (resData.data.real == "") {
                if (that.isRealNamePopShow) {
                  that.realNameConfig();
                  that.isRealNameVerified = true;
                }
              }
              if (resData.data.real) {
                //
                that.isFirstRecharge();
                //   if(resData.data.cash == "0.00") {
                //     that.rechargeConfig();
                //     that.isFirstTimeRecharge = true;
                // } else {
                //     that.isFirstTimeRecharge = false;
                //     //call is trade
                //   // that.isFirstTrade();
                // }
              }
            } else if (res.data.code === 0) {
              that.$toast.fail(resData.msg);
            } else if (res.data.code === -1) {
              that.$store.commit("changeLoginType", false);
              that.$router.push("/login");
            }
          })
          .catch(() => {
            that.isLoading = false;
          });
      }
    },
    isFirstRecharge() {
      //  if(resData.data.cash == "0.00") {
      //         that.rechargeConfig();
      //         that.isFirstTimeRecharge = true;
      //     } else {
      //         that.isFirstTimeRecharge = false;
      //         //call is trade
      //       // that.isFirstTrade();
      //     }
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "isfirst_recharge",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.data == 1) {
            that.isFirstTimeRecharge = false;
            // that.isFirstTrade();
            // localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            if (that.isRechargePopShow) {
              that.rechargeConfig();
              that.isFirstTimeRecharge = true;
            }
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    isFirstTrade() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "isfirst_deal",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          // console.log("res", res.data.data);
          if (res.data.data == 1) {
            that.isFirstTimeTrading = false;
            localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            that.tradeConfig();
            that.isFirstTimeTrading = true;
            localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    tradeConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "before_trading",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.before_trading = res.data.data;
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    cancelLines() {
      this.lineSwitching = false;
    },
    cancel() {
      this.isRealNameVerified = false;
    },
    cancelRecharge() {
      this.isFirstTimeRecharge = false;
    },
    cancelTrade() {
      this.isFirstTimeTrading = false;
    },
    goToRealName() {
      this.$router.push("/member/information/real_name");
    },
    goToRecharge() {
      this.$router.push("/member/recharge");
    },
    goToTrade() {
      this.$router.push("stockdetailed?symbol:'sh000001'");
    },
    exitLogin() {
      this.$store.commit("changeLoginType", false);
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("along");
      localStorage.setItem("user_number", "");
      //call service
      // this.logout();
      // localStorage.clear();
      this.$router.push("/login");
      location.reload();
    },
    isRealNamePopShowM() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "sysconfig",
              token: sessionStorage.getItem("token"),
              name: "is_real_name_popup",
            },
          })
          .then(function (res) {
            if (res.data.data == 1) {
              that.isRealNamePopShow = true;
            } else {
              // that.isFirstTimeTrading = true;
              // localStorage.setItem("isFirstTimeRecharge", true);
            }
          });
      }
    },
    isRechargePopShowM() {
      let that = this;
      if (that.$store.state.loginType) {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "sysconfig",
              token: sessionStorage.getItem("token"),
              name: "is_before_recharge",
            },
          })
          .then(function (res) {
            if (res.data.data == 1) {
              that.isRechargePopShow = true;
            } else {
              // that.isFirstTimeTrading = true;
              // localStorage.setItem("isFirstTimeRecharge", true);
            }
          });
      }
    },
    ChangeLine() {
      let that = this;
      that.$toast.loading({
        forbidClick: true,
      });
      let lineName = that.radioName;
      localStorage.setItem("lineUrl", lineName);
      this.lineSwitching = false;
      location.reload();
    },
   changeTab(value) {
   console.log(value);
      this.$toast.loading({
        forbidClick: true,
      });
      localStorage.setItem("lineUrl", this.lineTypes[value].url);
      setTimeout(() => {
        location.reload();
      }, 500)
    },
    getCurrentLineUrl() {
    console.log(this.urlBase);
      this.lineTypes.forEach((line,index) => {
        if(line.url == this.urlBase) {
          this.activeLineUrl = ref(index)
        }
      });
    },
    getURLs() {
      let that = this;
      that.lineArray=[];
      // that.lineTypes = [];
      // // that.lineArray= [];
      // that.domainList.forEach((i, index) => {
      //   let startTime = new Date().getTime();

      //   fetch(i.url,{ mode: 'no-cors' })
      //     .then(response => {
      //       let endTime = new Date().getTime();
      //       let elapsedTime = endTime - startTime;
      //       let item = {};
      //       item.time = elapsedTime + "ms";
      //       item.name = "线路 " + ++index;
      //       item.url=i.url;
      //       item.value = index;
      //       that.lineTypes.push(item);
      //       that.getCurrentLineUrl();

      //     })
      //     .catch(error => {
      //       console.error(error);
      //     });
      // });
      that.lineTypes.forEach((line, index) => {
      that.lineArray.push({
        text: `线路 ${index + 1}`,
        value: index,
      });
    });
    }
  },
  beforeCreated() {
    let that = this;
    that.getURLs();
  },

  mounted: function () {

    let that = this;
    that.getURLs();
    that.getCurrentLineUrl();
    that.getClientIpConfig();
    that.get_qchat_server_url();
    that.isRealNamePopShowM();
    that.isRechargePopShowM();
    that.getUser();
    that.getClientIP();
    that.getSysConfig();
    if (that.$store.state.rechargeType === true) {
      this.$toast.success({
        message: "充值申请成功，尽快完成后续操作，联系客服吧",
      });
    }
    that.$store.commit("rechargeTypeNine", false);

    this.selectedLine = localStorage.getItem("selectedLine");
    console.log('c',this.rechargeContent)
    // document.querySelector('.van-nav-bar').classList.remove('van-hairline--bottom'); // remove top bar bottom line

  },
};
</script>

<style scoped>
.van-cell {
  height: 36px !important;
}
.custom-title {
  font-size: 14px; 
} 
.van-cell__title {
  font-size: 13px !important; 
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: visible;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%; /* Adjust placement */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  visibility: visible;
  opacity: 1;
}

.tooltip-text {
  display: block;
}
.signIn:disabled{
  opacity:0.3;
}
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.navTextDesign {
  /* border: 1px solid #ffffff; */
  color: #ffffff;
  font-size: 14px;
  /* padding: 0px 10px; */
  /* margin-right: 15px; */
  /* border-radius: 6px; */
}
.members-wrap {
}
.members {
  /* background: #D02E27; */
  height: 195px;
  width: 94%;
  margin: 0 auto;
}
.members-img {
  width: 120px;
  margin: 0 auto;
  text-align: center;
  /* padding-top: 20px; */
}
.members-user {
  margin: 0;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 30px;
}
.members-money {
  font-size: 14px;
  /* color: #ffff; */
  margin: 0;
  padding-left: 6px;
}
.version {
  font-size: 14px;
  margin: 0;
  padding-left: 8px;
}
.members-down {
  margin-top: 10px;
}
.flexible-height {
  height: auto !important;
  min-height: 36px; 
  padding-top: 8px;
  padding-bottom: 0px;
}

.van-button--danger {
  /* background-color: #D02E27 !important; */
  border: 1px solid #D02E27 !important;
}
.van-button--plain.van-button--danger {
  color: #D02E27 !important;
}
@media (max-width: 1180px) { 
  /deep/ .van-nav-bar__content {
    height: 48px !important;
  }
} 
</style>
<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}

#lineUrlDropdown .van-dropdown-item__option {
  background-color: #D02E27;
  padding: 5px 10px;
  text-align: center;
  font-size: 12px;
}

#lineUrlDropdown .van-dropdown-item__content {
  background-color: #D02E27;
  width: 87px;
  position: absolute;
  left: 16px;
  top: 2px;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

#lineUrlDropdown .van-overlay {
  background-color: transparent;
}

#lineUrlDropdown .van-dropdown-menu__item {
  background-color: #D02E27;
}

#lineUrlDropdown .van-dropdown-menu__title::after {
  display: none;
}

#lineUrlDropdown .van-dropdown-item__option .van-cell__value {
  display: none;
}

#lineUrlDropdown .van-dropdown-item__option .van-cell__title {
  color: #fff;
}

#lineUrlDropMenu .van-dropdown-menu {
  /* border: 1px solid #ffffff; */
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}

#lineUrlDropdown .van-dropdown-menu__bar {
  height: auto;
  box-shadow: none;
}

#lineUrlDropdown .van-dropdown-menu__title {
  color: #fff;
  background-color: #D02E27;
}

#lineUrlDropdown .van-cell::after {
  border-bottom: 3px solid #fff;
}

.button-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.help-button {
  height: 26px;
  width: 26px;
  padding: 0;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-content {
  margin: 0;
  padding: 4px 8px;
  font-size: 14px;
  max-width: 200px;
  text-align: left;
  white-space: normal;
  color: #fff;
}

.first-time-recharge-popup {
    overflow: hidden !important; 
    max-height: 100vh;
    padding-bottom: -10px !important;
}
.common-bg{
  width:95% !important;
  margin:10px 10px 5px 10px !important;
  border:1px solid #e3e3e3!important;
  border-radius: 20px !important;
  overflow: hidden;
  background-color: white;

}
.common-bg1{
  width:95% !important;
  margin:0px 10px 5px 10px !important;
  padding-bottom: 20px;
  border:1px solid #e3e3e3!important;
  border-radius: 20px !important;
  overflow: visible;
  background-color: white;
}

.outside-container {
  background: linear-gradient(to bottom, #D02E27 0%, white 60%, white 100%) !important;
  padding-top: 1px;
}


</style>


// WEBPACK FOOTER //
// src/components/Members.vue